(window["webpackJsonp"] = window["webpackJsonp"] || []).push([["main"],{

/***/ "./node_modules/moment/locale sync recursive ^\\.\\/.*$":
/*!**************************************************!*\
  !*** ./node_modules/moment/locale sync ^\.\/.*$ ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "./node_modules/moment/locale/af.js",
	"./af.js": "./node_modules/moment/locale/af.js",
	"./ar": "./node_modules/moment/locale/ar.js",
	"./ar-dz": "./node_modules/moment/locale/ar-dz.js",
	"./ar-dz.js": "./node_modules/moment/locale/ar-dz.js",
	"./ar-kw": "./node_modules/moment/locale/ar-kw.js",
	"./ar-kw.js": "./node_modules/moment/locale/ar-kw.js",
	"./ar-ly": "./node_modules/moment/locale/ar-ly.js",
	"./ar-ly.js": "./node_modules/moment/locale/ar-ly.js",
	"./ar-ma": "./node_modules/moment/locale/ar-ma.js",
	"./ar-ma.js": "./node_modules/moment/locale/ar-ma.js",
	"./ar-sa": "./node_modules/moment/locale/ar-sa.js",
	"./ar-sa.js": "./node_modules/moment/locale/ar-sa.js",
	"./ar-tn": "./node_modules/moment/locale/ar-tn.js",
	"./ar-tn.js": "./node_modules/moment/locale/ar-tn.js",
	"./ar.js": "./node_modules/moment/locale/ar.js",
	"./az": "./node_modules/moment/locale/az.js",
	"./az.js": "./node_modules/moment/locale/az.js",
	"./be": "./node_modules/moment/locale/be.js",
	"./be.js": "./node_modules/moment/locale/be.js",
	"./bg": "./node_modules/moment/locale/bg.js",
	"./bg.js": "./node_modules/moment/locale/bg.js",
	"./bm": "./node_modules/moment/locale/bm.js",
	"./bm.js": "./node_modules/moment/locale/bm.js",
	"./bn": "./node_modules/moment/locale/bn.js",
	"./bn-bd": "./node_modules/moment/locale/bn-bd.js",
	"./bn-bd.js": "./node_modules/moment/locale/bn-bd.js",
	"./bn.js": "./node_modules/moment/locale/bn.js",
	"./bo": "./node_modules/moment/locale/bo.js",
	"./bo.js": "./node_modules/moment/locale/bo.js",
	"./br": "./node_modules/moment/locale/br.js",
	"./br.js": "./node_modules/moment/locale/br.js",
	"./bs": "./node_modules/moment/locale/bs.js",
	"./bs.js": "./node_modules/moment/locale/bs.js",
	"./ca": "./node_modules/moment/locale/ca.js",
	"./ca.js": "./node_modules/moment/locale/ca.js",
	"./cs": "./node_modules/moment/locale/cs.js",
	"./cs.js": "./node_modules/moment/locale/cs.js",
	"./cv": "./node_modules/moment/locale/cv.js",
	"./cv.js": "./node_modules/moment/locale/cv.js",
	"./cy": "./node_modules/moment/locale/cy.js",
	"./cy.js": "./node_modules/moment/locale/cy.js",
	"./da": "./node_modules/moment/locale/da.js",
	"./da.js": "./node_modules/moment/locale/da.js",
	"./de": "./node_modules/moment/locale/de.js",
	"./de-at": "./node_modules/moment/locale/de-at.js",
	"./de-at.js": "./node_modules/moment/locale/de-at.js",
	"./de-ch": "./node_modules/moment/locale/de-ch.js",
	"./de-ch.js": "./node_modules/moment/locale/de-ch.js",
	"./de.js": "./node_modules/moment/locale/de.js",
	"./dv": "./node_modules/moment/locale/dv.js",
	"./dv.js": "./node_modules/moment/locale/dv.js",
	"./el": "./node_modules/moment/locale/el.js",
	"./el.js": "./node_modules/moment/locale/el.js",
	"./en-au": "./node_modules/moment/locale/en-au.js",
	"./en-au.js": "./node_modules/moment/locale/en-au.js",
	"./en-ca": "./node_modules/moment/locale/en-ca.js",
	"./en-ca.js": "./node_modules/moment/locale/en-ca.js",
	"./en-gb": "./node_modules/moment/locale/en-gb.js",
	"./en-gb.js": "./node_modules/moment/locale/en-gb.js",
	"./en-ie": "./node_modules/moment/locale/en-ie.js",
	"./en-ie.js": "./node_modules/moment/locale/en-ie.js",
	"./en-il": "./node_modules/moment/locale/en-il.js",
	"./en-il.js": "./node_modules/moment/locale/en-il.js",
	"./en-in": "./node_modules/moment/locale/en-in.js",
	"./en-in.js": "./node_modules/moment/locale/en-in.js",
	"./en-nz": "./node_modules/moment/locale/en-nz.js",
	"./en-nz.js": "./node_modules/moment/locale/en-nz.js",
	"./en-sg": "./node_modules/moment/locale/en-sg.js",
	"./en-sg.js": "./node_modules/moment/locale/en-sg.js",
	"./eo": "./node_modules/moment/locale/eo.js",
	"./eo.js": "./node_modules/moment/locale/eo.js",
	"./es": "./node_modules/moment/locale/es.js",
	"./es-do": "./node_modules/moment/locale/es-do.js",
	"./es-do.js": "./node_modules/moment/locale/es-do.js",
	"./es-mx": "./node_modules/moment/locale/es-mx.js",
	"./es-mx.js": "./node_modules/moment/locale/es-mx.js",
	"./es-us": "./node_modules/moment/locale/es-us.js",
	"./es-us.js": "./node_modules/moment/locale/es-us.js",
	"./es.js": "./node_modules/moment/locale/es.js",
	"./et": "./node_modules/moment/locale/et.js",
	"./et.js": "./node_modules/moment/locale/et.js",
	"./eu": "./node_modules/moment/locale/eu.js",
	"./eu.js": "./node_modules/moment/locale/eu.js",
	"./fa": "./node_modules/moment/locale/fa.js",
	"./fa.js": "./node_modules/moment/locale/fa.js",
	"./fi": "./node_modules/moment/locale/fi.js",
	"./fi.js": "./node_modules/moment/locale/fi.js",
	"./fil": "./node_modules/moment/locale/fil.js",
	"./fil.js": "./node_modules/moment/locale/fil.js",
	"./fo": "./node_modules/moment/locale/fo.js",
	"./fo.js": "./node_modules/moment/locale/fo.js",
	"./fr": "./node_modules/moment/locale/fr.js",
	"./fr-ca": "./node_modules/moment/locale/fr-ca.js",
	"./fr-ca.js": "./node_modules/moment/locale/fr-ca.js",
	"./fr-ch": "./node_modules/moment/locale/fr-ch.js",
	"./fr-ch.js": "./node_modules/moment/locale/fr-ch.js",
	"./fr.js": "./node_modules/moment/locale/fr.js",
	"./fy": "./node_modules/moment/locale/fy.js",
	"./fy.js": "./node_modules/moment/locale/fy.js",
	"./ga": "./node_modules/moment/locale/ga.js",
	"./ga.js": "./node_modules/moment/locale/ga.js",
	"./gd": "./node_modules/moment/locale/gd.js",
	"./gd.js": "./node_modules/moment/locale/gd.js",
	"./gl": "./node_modules/moment/locale/gl.js",
	"./gl.js": "./node_modules/moment/locale/gl.js",
	"./gom-deva": "./node_modules/moment/locale/gom-deva.js",
	"./gom-deva.js": "./node_modules/moment/locale/gom-deva.js",
	"./gom-latn": "./node_modules/moment/locale/gom-latn.js",
	"./gom-latn.js": "./node_modules/moment/locale/gom-latn.js",
	"./gu": "./node_modules/moment/locale/gu.js",
	"./gu.js": "./node_modules/moment/locale/gu.js",
	"./he": "./node_modules/moment/locale/he.js",
	"./he.js": "./node_modules/moment/locale/he.js",
	"./hi": "./node_modules/moment/locale/hi.js",
	"./hi.js": "./node_modules/moment/locale/hi.js",
	"./hr": "./node_modules/moment/locale/hr.js",
	"./hr.js": "./node_modules/moment/locale/hr.js",
	"./hu": "./node_modules/moment/locale/hu.js",
	"./hu.js": "./node_modules/moment/locale/hu.js",
	"./hy-am": "./node_modules/moment/locale/hy-am.js",
	"./hy-am.js": "./node_modules/moment/locale/hy-am.js",
	"./id": "./node_modules/moment/locale/id.js",
	"./id.js": "./node_modules/moment/locale/id.js",
	"./is": "./node_modules/moment/locale/is.js",
	"./is.js": "./node_modules/moment/locale/is.js",
	"./it": "./node_modules/moment/locale/it.js",
	"./it-ch": "./node_modules/moment/locale/it-ch.js",
	"./it-ch.js": "./node_modules/moment/locale/it-ch.js",
	"./it.js": "./node_modules/moment/locale/it.js",
	"./ja": "./node_modules/moment/locale/ja.js",
	"./ja.js": "./node_modules/moment/locale/ja.js",
	"./jv": "./node_modules/moment/locale/jv.js",
	"./jv.js": "./node_modules/moment/locale/jv.js",
	"./ka": "./node_modules/moment/locale/ka.js",
	"./ka.js": "./node_modules/moment/locale/ka.js",
	"./kk": "./node_modules/moment/locale/kk.js",
	"./kk.js": "./node_modules/moment/locale/kk.js",
	"./km": "./node_modules/moment/locale/km.js",
	"./km.js": "./node_modules/moment/locale/km.js",
	"./kn": "./node_modules/moment/locale/kn.js",
	"./kn.js": "./node_modules/moment/locale/kn.js",
	"./ko": "./node_modules/moment/locale/ko.js",
	"./ko.js": "./node_modules/moment/locale/ko.js",
	"./ku": "./node_modules/moment/locale/ku.js",
	"./ku.js": "./node_modules/moment/locale/ku.js",
	"./ky": "./node_modules/moment/locale/ky.js",
	"./ky.js": "./node_modules/moment/locale/ky.js",
	"./lb": "./node_modules/moment/locale/lb.js",
	"./lb.js": "./node_modules/moment/locale/lb.js",
	"./lo": "./node_modules/moment/locale/lo.js",
	"./lo.js": "./node_modules/moment/locale/lo.js",
	"./lt": "./node_modules/moment/locale/lt.js",
	"./lt.js": "./node_modules/moment/locale/lt.js",
	"./lv": "./node_modules/moment/locale/lv.js",
	"./lv.js": "./node_modules/moment/locale/lv.js",
	"./me": "./node_modules/moment/locale/me.js",
	"./me.js": "./node_modules/moment/locale/me.js",
	"./mi": "./node_modules/moment/locale/mi.js",
	"./mi.js": "./node_modules/moment/locale/mi.js",
	"./mk": "./node_modules/moment/locale/mk.js",
	"./mk.js": "./node_modules/moment/locale/mk.js",
	"./ml": "./node_modules/moment/locale/ml.js",
	"./ml.js": "./node_modules/moment/locale/ml.js",
	"./mn": "./node_modules/moment/locale/mn.js",
	"./mn.js": "./node_modules/moment/locale/mn.js",
	"./mr": "./node_modules/moment/locale/mr.js",
	"./mr.js": "./node_modules/moment/locale/mr.js",
	"./ms": "./node_modules/moment/locale/ms.js",
	"./ms-my": "./node_modules/moment/locale/ms-my.js",
	"./ms-my.js": "./node_modules/moment/locale/ms-my.js",
	"./ms.js": "./node_modules/moment/locale/ms.js",
	"./mt": "./node_modules/moment/locale/mt.js",
	"./mt.js": "./node_modules/moment/locale/mt.js",
	"./my": "./node_modules/moment/locale/my.js",
	"./my.js": "./node_modules/moment/locale/my.js",
	"./nb": "./node_modules/moment/locale/nb.js",
	"./nb.js": "./node_modules/moment/locale/nb.js",
	"./ne": "./node_modules/moment/locale/ne.js",
	"./ne.js": "./node_modules/moment/locale/ne.js",
	"./nl": "./node_modules/moment/locale/nl.js",
	"./nl-be": "./node_modules/moment/locale/nl-be.js",
	"./nl-be.js": "./node_modules/moment/locale/nl-be.js",
	"./nl.js": "./node_modules/moment/locale/nl.js",
	"./nn": "./node_modules/moment/locale/nn.js",
	"./nn.js": "./node_modules/moment/locale/nn.js",
	"./oc-lnc": "./node_modules/moment/locale/oc-lnc.js",
	"./oc-lnc.js": "./node_modules/moment/locale/oc-lnc.js",
	"./pa-in": "./node_modules/moment/locale/pa-in.js",
	"./pa-in.js": "./node_modules/moment/locale/pa-in.js",
	"./pl": "./node_modules/moment/locale/pl.js",
	"./pl.js": "./node_modules/moment/locale/pl.js",
	"./pt": "./node_modules/moment/locale/pt.js",
	"./pt-br": "./node_modules/moment/locale/pt-br.js",
	"./pt-br.js": "./node_modules/moment/locale/pt-br.js",
	"./pt.js": "./node_modules/moment/locale/pt.js",
	"./ro": "./node_modules/moment/locale/ro.js",
	"./ro.js": "./node_modules/moment/locale/ro.js",
	"./ru": "./node_modules/moment/locale/ru.js",
	"./ru.js": "./node_modules/moment/locale/ru.js",
	"./sd": "./node_modules/moment/locale/sd.js",
	"./sd.js": "./node_modules/moment/locale/sd.js",
	"./se": "./node_modules/moment/locale/se.js",
	"./se.js": "./node_modules/moment/locale/se.js",
	"./si": "./node_modules/moment/locale/si.js",
	"./si.js": "./node_modules/moment/locale/si.js",
	"./sk": "./node_modules/moment/locale/sk.js",
	"./sk.js": "./node_modules/moment/locale/sk.js",
	"./sl": "./node_modules/moment/locale/sl.js",
	"./sl.js": "./node_modules/moment/locale/sl.js",
	"./sq": "./node_modules/moment/locale/sq.js",
	"./sq.js": "./node_modules/moment/locale/sq.js",
	"./sr": "./node_modules/moment/locale/sr.js",
	"./sr-cyrl": "./node_modules/moment/locale/sr-cyrl.js",
	"./sr-cyrl.js": "./node_modules/moment/locale/sr-cyrl.js",
	"./sr.js": "./node_modules/moment/locale/sr.js",
	"./ss": "./node_modules/moment/locale/ss.js",
	"./ss.js": "./node_modules/moment/locale/ss.js",
	"./sv": "./node_modules/moment/locale/sv.js",
	"./sv.js": "./node_modules/moment/locale/sv.js",
	"./sw": "./node_modules/moment/locale/sw.js",
	"./sw.js": "./node_modules/moment/locale/sw.js",
	"./ta": "./node_modules/moment/locale/ta.js",
	"./ta.js": "./node_modules/moment/locale/ta.js",
	"./te": "./node_modules/moment/locale/te.js",
	"./te.js": "./node_modules/moment/locale/te.js",
	"./tet": "./node_modules/moment/locale/tet.js",
	"./tet.js": "./node_modules/moment/locale/tet.js",
	"./tg": "./node_modules/moment/locale/tg.js",
	"./tg.js": "./node_modules/moment/locale/tg.js",
	"./th": "./node_modules/moment/locale/th.js",
	"./th.js": "./node_modules/moment/locale/th.js",
	"./tk": "./node_modules/moment/locale/tk.js",
	"./tk.js": "./node_modules/moment/locale/tk.js",
	"./tl-ph": "./node_modules/moment/locale/tl-ph.js",
	"./tl-ph.js": "./node_modules/moment/locale/tl-ph.js",
	"./tlh": "./node_modules/moment/locale/tlh.js",
	"./tlh.js": "./node_modules/moment/locale/tlh.js",
	"./tr": "./node_modules/moment/locale/tr.js",
	"./tr.js": "./node_modules/moment/locale/tr.js",
	"./tzl": "./node_modules/moment/locale/tzl.js",
	"./tzl.js": "./node_modules/moment/locale/tzl.js",
	"./tzm": "./node_modules/moment/locale/tzm.js",
	"./tzm-latn": "./node_modules/moment/locale/tzm-latn.js",
	"./tzm-latn.js": "./node_modules/moment/locale/tzm-latn.js",
	"./tzm.js": "./node_modules/moment/locale/tzm.js",
	"./ug-cn": "./node_modules/moment/locale/ug-cn.js",
	"./ug-cn.js": "./node_modules/moment/locale/ug-cn.js",
	"./uk": "./node_modules/moment/locale/uk.js",
	"./uk.js": "./node_modules/moment/locale/uk.js",
	"./ur": "./node_modules/moment/locale/ur.js",
	"./ur.js": "./node_modules/moment/locale/ur.js",
	"./uz": "./node_modules/moment/locale/uz.js",
	"./uz-latn": "./node_modules/moment/locale/uz-latn.js",
	"./uz-latn.js": "./node_modules/moment/locale/uz-latn.js",
	"./uz.js": "./node_modules/moment/locale/uz.js",
	"./vi": "./node_modules/moment/locale/vi.js",
	"./vi.js": "./node_modules/moment/locale/vi.js",
	"./x-pseudo": "./node_modules/moment/locale/x-pseudo.js",
	"./x-pseudo.js": "./node_modules/moment/locale/x-pseudo.js",
	"./yo": "./node_modules/moment/locale/yo.js",
	"./yo.js": "./node_modules/moment/locale/yo.js",
	"./zh-cn": "./node_modules/moment/locale/zh-cn.js",
	"./zh-cn.js": "./node_modules/moment/locale/zh-cn.js",
	"./zh-hk": "./node_modules/moment/locale/zh-hk.js",
	"./zh-hk.js": "./node_modules/moment/locale/zh-hk.js",
	"./zh-mo": "./node_modules/moment/locale/zh-mo.js",
	"./zh-mo.js": "./node_modules/moment/locale/zh-mo.js",
	"./zh-tw": "./node_modules/moment/locale/zh-tw.js",
	"./zh-tw.js": "./node_modules/moment/locale/zh-tw.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./node_modules/moment/locale sync recursive ^\\.\\/.*$";

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html":
/*!**************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html ***!
  \**************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<ngx-loader></ngx-loader>\n\n<div class=\"d-flex\">\n  <jbs-navside *ngIf=\"authService.Autenticado()\" [menus]=\"menus\"> </jbs-navside>\n\n  <div\n    [ngClass]=\"{\n      app: true,\n      logado: authService.Autenticado()\n    }\"\n  >\n    <dtp-nav-top\n      [menuLateral]=\"[]\"\n      *ngIf=\"authService.Autenticado()\"\n      linkLogo=\"/assets/iconesAplicacao/logo-black.png\"\n    >\n    </dtp-nav-top>\n\n    <dtp-cardpadrao [logado]=\"authService.Autenticado()\">\n      <router-outlet (activate)=\"rotaAlterada($event)\"></router-outlet>\n    </dtp-cardpadrao>\n  </div>\n</div>\n\n<!-- <dtp-loader></dtp-loader> -->\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/uboi/componentes/jbs-navside/jbs-navside.component.html":
/*!***************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/uboi/componentes/jbs-navside/jbs-navside.component.html ***!
  \***************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<nav [ngClass]=\"{ 'main-menu': true, expanded: expanded }\">\n  <button (click)=\"expanded = !expanded\" class=\"expand\">\n    <span class=\"icon\">\n      <i *ngIf=\"!expanded\" class=\"bg-arrow-right\" aria-hidden=\"true\"></i>\n      <i *ngIf=\"expanded\" class=\"bg-arrow-left\" aria-hidden=\"true\"></i>\n    </span>\n    <span class=\"title-button\">Recolher</span>\n  </button>\n\n  <ul *ngIf=\"menus\">\n    <li\n      *ngFor=\"let m of menus[0]?.lSubcategorias\"\n      [title]=\"m.Display.length > 59 ? m.display : ''\"\n    >\n      <a [routerLink]=\"m.Url\" (click)=\"onClick()\" [state]=\"m.Permissoes\">\n        <span class=\"container-icon\">\n          <i class=\"fa nav-icon\">\n            <dtp-icone [caminho]=\"m.Icone\"></dtp-icone>\n          </i>\n        </span>\n        <span\n          class=\"nav-text limit-nav-text\"\n          style=\"-webkit-box-orient: vertical\"\n          [ngClass]=\"m.Display == 'Transportadoras' ? 'nowrap' : ''\"\n        >\n          {{ m.Display }}\n        </span>\n        <span class=\"container-arrow-icon\">\n          <i class=\"bg-arrow-right-small\"></i>\n        </span>\n      </a>\n    </li>\n  </ul>\n</nav>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/uboi/core/autorizacao/login/login.component.html":
/*!********************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/uboi/core/autorizacao/login/login.component.html ***!
  \********************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"row\" style=\"margin: 0; padding: 0\">\n  <div>\n    <span style=\"font-size:10px; position:absolute; right:0; top: 0; color:rgb(0 0 0 / 30%)\">v.0.0.2</span>\n   </div>\n  <div class=\"box-login\">\n    <form (submit)=\"ValidarLogin();\" id=\"loginForm\" name=\"loginForm\" target=\"_top\" class=\"loginmodal-container\">\n      <div class=\"row text-center mb-3\" id=\"ctnerLogo\">\n        <img src=\"assets/iconesAplicacao/logo-login.png\" class=\"rounded mx-auto d-block\" />\n      </div>\n      <!-- <h3 class=\"mt-2\">\n        Acesso ao sistema\n      </h3>\n      <hr /> -->\n      <div>\n        <dtp-ctnerinput>\n          <input class=\"form-control\" placeholder=\"Login\" [value]=\"usuario.Login\" customfocus\n            (keyup)=\"usuario.Login = $event.target.value\" />\n          <input class=\"form-control mt-2\" placeholder=\"Senha\" type=\"password\" [value]=\"usuario.Senha\"\n            (keyup)=\"usuario.Senha = $event.target.value\" />\n        </dtp-ctnerinput>\n        <re-captcha #reCaptcha *ngIf=\"siteKey\" (resolved)=\"$event && Login($event)\" size=\"invisible\"\n          [siteKey]=\"siteKey\">\n        </re-captcha>\n      </div>\n      <div class=\"mt-3\">\n        <dtp-genericbutton size=\"100%\" [desabilitado]=\"usuario.Login.length == 0 || usuario.Senha.length == 0\"\n          classe=\"borderRadius azul\" desabilitado=\"false\" altura=\"58\" largura=\"365\" descricao=\"Entrar\" tipo=\"submit\">\n        </dtp-genericbutton>\n      </div>\n\n      <div *ngIf=\"expirado\" class=\"mt-4\">\n        <dtp-alert class=\"mb-0\" [mostrar]=\"expirado\" estilo=\"secondary\"\n          mensagem=\"Suas credenciais se expiraram. Por favor, entre novamente!\"></dtp-alert>\n      </div>\n\n    </form>\n\n  </div>\n\n  <dtp-generic-modal #modalPasswordReset titulo=\"Redefinição de senha\" tamanho=\"md\">\n    <div body *ngIf=\"formPasswordReset\">\n      <form [formGroup]=\"formPasswordReset\">\n        <dtp-alert icone-esquerda=\"fas fa-key\" prefixo=\"Uma nova senha deve ser cadastrada.\"\n          mensagem=\"Por favor, preencha os campos abaixo:\"></dtp-alert>\n        <div class=\"row d-flex align-items-center mt-4\">\n          <div class=\"col-md-12\">\n            <dtp-ctnerinput label=\"Digite a nova senha\" [form]=\"formPasswordReset\" [configAtiva]=\"configurarCampos\"\n              campo=\"password\">\n              <input type=\"password\" class=\"form-control\" formControlName=\"password\" />\n            </dtp-ctnerinput>\n          </div>\n        </div>\n        <div class=\"row mt-2\">\n          <div class=\"col-md-12\">\n            <dtp-ctnerinput label=\"Digite novamente a nova senha\" [form]=\"formPasswordReset\"\n              [configAtiva]=\"configurarCampos\" campo=\"password_repeat\">\n              <input type=\"password\" class=\"form-control\" formControlName=\"password_repeat\" />\n            </dtp-ctnerinput>\n          </div>\n        </div>\n\n      </form>\n    </div>\n    <div footer style=\"width: 100%\" *ngIf=\"formPasswordReset\">\n      <div class=\"row text-center\">\n\n        <div class=\"col-lg-12\">\n          <dtp-genericbutton (metodoPai)=\"SavePasswordReset()\" focado=\"true\" altura=\"58\" largura=\"365\"\n            [desabilitado]=\"formPasswordReset.invalid\" descricao=\"Redefinir senha\" classe=\"gradamarelo\" teclaatalho=\"R\">\n          </dtp-genericbutton>\n        </div>\n      </div>\n    </div>\n  </dtp-generic-modal>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/uboi/core/autorizacao/two-factor/two-factor.component.html":
/*!******************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/uboi/core/autorizacao/two-factor/two-factor.component.html ***!
  \******************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"row\" style=\"margin: 0; padding: 0\">\n  <div>\n    <span\n      style=\"\n        font-size: 10px;\n        position: absolute;\n        right: 0;\n        top: 0;\n        color: rgb(0 0 0 / 30%);\n      \"\n      >v.0.0.2</span\n    >\n  </div>\n  <div class=\"box-login\">\n    <form\n      (submit)=\"ValidarMfaLogin()\"\n      id=\"mfaLoginForm\"\n      name=\"mfaLoginForm\"\n      target=\"_top\"\n      class=\"loginmodal-container\"\n    >\n      <div class=\"row text-center mb-3\" id=\"ctnerLogo\">\n        <img\n          src=\"assets/iconesAplicacao/logo-login.png\"\n          class=\"rounded mx-auto d-block\"\n        />\n      </div>\n      <!-- <h3 class=\"mt-2\">\n        Acesso ao sistema\n      </h3>\n      <hr /> -->\n      <div>\n        <span class=\"two-auth__subtitle mt-5\">\n          Por favor, verifique seu e-mail e digite abaixo o código recebido de 6\n          digitos para fazer o login:\n        </span>\n      </div>\n\n      <div>\n        <dtp-ctnerinput class=\"field\">\n          <input\n            class=\"form-control\"\n            placeholder=\"Codigo\"\n            [value]=\"mfaToken.token\"\n            customfocus\n            (keyup)=\"mfaToken.token = $event.target.value\"\n            maxlength=\"6\"\n            required\n          />\n        </dtp-ctnerinput>\n      </div>\n      <div class=\"mt-3\">\n        <dtp-genericbutton\n          size=\"100%\"\n          classe=\"borderRadius azul\"\n          desabilitado=\"false\"\n          altura=\"58\"\n          largura=\"100%\"\n          descricao=\"Verificar\"\n          tipo=\"submit\"\n        >\n        </dtp-genericbutton>\n      </div>\n      <div class=\"two-auth__subtitle mt-5\">\n        Não recebeu o código?\n        <br />\n        <a\n          (click)=\"ResendMfaToken()\"\n          class=\"two-auth__subtitle\"\n          style=\"cursor: pointer\"\n          >Clique aqui</a\n        >\n        para solicitar um novo.\n      </div>\n    </form>\n  </div>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/uboi/core/inicio/inicio.component.html":
/*!**********************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/uboi/core/inicio/inicio.component.html ***!
  \**********************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<dtp-fixed-header label=\"Dashboard\">\n</dtp-fixed-header>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/uboi/paginas/inicio/pagina-inicio.component.html":
/*!********************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/uboi/paginas/inicio/pagina-inicio.component.html ***!
  \********************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<router-outlet></router-outlet>\n<notifier-container></notifier-container>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/uboi/paginas/termos-contrato/termos-contrato-cadastro/termos-contrato-cadastro.component.html":
/*!*****************************************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/uboi/paginas/termos-contrato/termos-contrato-cadastro/termos-contrato-cadastro.component.html ***!
  \*****************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<form>\n    <dtp-formcadastro titulo=\"Termos de Uso\" tituloid=\"Id\" [id]=\"0\" [comQRCode]=\"false\">\n        <div class=\"row mt-2\">\n            <div class=\"col-lg-6\">\n                <div class=\"mt-2\">\n                    <dtp-section-header descricao=\"Carregar novo contrato\"></dtp-section-header>\n                </div>\n                <div class=\"mt-2\">\n                    <prime-ng-uploader (registrarAnexosNoBanco)=\"SalvarAnexo($event)\"></prime-ng-uploader>\n                </div>\n            </div>\n            <div class=\"col-lg-6\">\n                <div class=\"mt-2\">\n                    <dtp-section-header descricao=\"Contrato\"></dtp-section-header>\n                </div>\n\n                <div class=\"mt-2\">\n                    <iframe *ngIf=\"linkContrato\" [src]=\"linkTratado\" type=\"application/pdf\"\n                        style=\"border: 0;width: 100%; height: 600px\"></iframe>\n                        \n                    <dtp-alert *ngIf=\"!linkContrato\" icone-esquerda=\"fa fa-exclamation-triangle\" prefixo=\"Atenção :\" mensagem=\"Não existe contrato cadastrado!\">\n                    </dtp-alert>\n                </div>\n            </div>\n        </div>\n    </dtp-formcadastro>\n</form>");

/***/ }),

/***/ "./node_modules/tslib/tslib.es6.js":
/*!*****************************************!*\
  !*** ./node_modules/tslib/tslib.es6.js ***!
  \*****************************************/
/*! exports provided: __extends, __assign, __rest, __decorate, __param, __metadata, __awaiter, __generator, __exportStar, __values, __read, __spread, __spreadArrays, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__extends", function() { return __extends; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__rest", function() { return __rest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__decorate", function() { return __decorate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__param", function() { return __param; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__metadata", function() { return __metadata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__awaiter", function() { return __awaiter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__generator", function() { return __generator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__exportStar", function() { return __exportStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__values", function() { return __values; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__read", function() { return __read; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spread", function() { return __spread; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spreadArrays", function() { return __spreadArrays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__await", function() { return __await; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncGenerator", function() { return __asyncGenerator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncDelegator", function() { return __asyncDelegator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncValues", function() { return __asyncValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__makeTemplateObject", function() { return __makeTemplateObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importStar", function() { return __importStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importDefault", function() { return __importDefault; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),

/***/ "./src/$$_lazy_route_resource lazy recursive":
/*!**********************************************************!*\
  !*** ./src/$$_lazy_route_resource lazy namespace object ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function webpackEmptyAsyncContext(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(function() {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	});
}
webpackEmptyAsyncContext.keys = function() { return []; };
webpackEmptyAsyncContext.resolve = webpackEmptyAsyncContext;
module.exports = webpackEmptyAsyncContext;
webpackEmptyAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";

/***/ }),

/***/ "./src/app/app-routing.module.ts":
/*!***************************************!*\
  !*** ./src/app/app-routing.module.ts ***!
  \***************************************/
/*! exports provided: AppRoutingModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppRoutingModule", function() { return AppRoutingModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");



const routes = [];
let AppRoutingModule = class AppRoutingModule {
};
AppRoutingModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        imports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"].forRoot(routes, { useHash: true })],
        exports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"]]
    })
], AppRoutingModule);



/***/ }),

/***/ "./src/app/app.component.css":
/*!***********************************!*\
  !*** ./src/app/app.component.css ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".side {\n    width: 85px;\n}\n\n.app {\n    width: 100%;\n}\n\n.app.logado {\n    padding-left: 70px;\n}\n\n.app.logado:before {\n    content: '';\n    /* background-image: url(./../assets/backgrounds/background-padrao.jpg); */\n    background-color: var(--cor-secundaria);\n    background-repeat: no-repeat;\n    background-position: top;\n    background-size: cover;\n    width: 100%;\n    height: 110px;\n    position: fixed;\n    left: 0;\n    top: 0;\n    z-index: 1019;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvYXBwLmNvbXBvbmVudC5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7SUFDSSxXQUFXO0FBQ2Y7O0FBRUE7SUFDSSxXQUFXO0FBQ2Y7O0FBRUE7SUFDSSxrQkFBa0I7QUFDdEI7O0FBRUE7SUFDSSxXQUFXO0lBQ1gsMEVBQTBFO0lBQzFFLHVDQUF1QztJQUN2Qyw0QkFBNEI7SUFDNUIsd0JBQXdCO0lBQ3hCLHNCQUFzQjtJQUN0QixXQUFXO0lBQ1gsYUFBYTtJQUNiLGVBQWU7SUFDZixPQUFPO0lBQ1AsTUFBTTtJQUNOLGFBQWE7QUFDakIiLCJmaWxlIjoic3JjL2FwcC9hcHAuY29tcG9uZW50LmNzcyIsInNvdXJjZXNDb250ZW50IjpbIi5zaWRlIHtcbiAgICB3aWR0aDogODVweDtcbn1cblxuLmFwcCB7XG4gICAgd2lkdGg6IDEwMCU7XG59XG5cbi5hcHAubG9nYWRvIHtcbiAgICBwYWRkaW5nLWxlZnQ6IDcwcHg7XG59XG5cbi5hcHAubG9nYWRvOmJlZm9yZSB7XG4gICAgY29udGVudDogJyc7XG4gICAgLyogYmFja2dyb3VuZC1pbWFnZTogdXJsKC4vLi4vYXNzZXRzL2JhY2tncm91bmRzL2JhY2tncm91bmQtcGFkcmFvLmpwZyk7ICovXG4gICAgYmFja2dyb3VuZC1jb2xvcjogdmFyKC0tY29yLXNlY3VuZGFyaWEpO1xuICAgIGJhY2tncm91bmQtcmVwZWF0OiBuby1yZXBlYXQ7XG4gICAgYmFja2dyb3VuZC1wb3NpdGlvbjogdG9wO1xuICAgIGJhY2tncm91bmQtc2l6ZTogY292ZXI7XG4gICAgd2lkdGg6IDEwMCU7XG4gICAgaGVpZ2h0OiAxMTBweDtcbiAgICBwb3NpdGlvbjogZml4ZWQ7XG4gICAgbGVmdDogMDtcbiAgICB0b3A6IDA7XG4gICAgei1pbmRleDogMTAxOTtcbn0iXX0= */");

/***/ }),

/***/ "./src/app/app.component.ts":
/*!**********************************!*\
  !*** ./src/app/app.component.ts ***!
  \**********************************/
/*! exports provided: AppComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppComponent", function() { return AppComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var dtp_angular_library__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! dtp-angular-library */ "./node_modules/dtp-angular-library/fesm2015/dtp-angular-library.js");
/* harmony import */ var src_app_uboi_base_services_jbs_mfa_token_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! src/app/uboi/base/services/jbs-mfa-token.service */ "./src/app/uboi/base/services/jbs-mfa-token.service.ts");




let AppComponent = class AppComponent {
    constructor(authService, localStorage, serviceMenu, mfaTokenService) {
        this.authService = authService;
        this.localStorage = localStorage;
        this.serviceMenu = serviceMenu;
        this.mfaTokenService = mfaTokenService;
        this.title = "datapar-uboi-webapp";
        this.permissoes = new dtp_angular_library__WEBPACK_IMPORTED_MODULE_2__["MenuPermissoes"]();
    }
    atualizarMenus() {
        this.serviceMenu.Obter().subscribe((i) => {
            this.menus = i;
            const menusarray = i;
            const permissoes = menusarray.map((menu) => {
                return menu.lSubcategorias.map((item) => {
                    return {
                        codfrm: item.CodFrm,
                        rota: item.Url,
                        display: item.Display,
                        icone: item.Icone,
                        custom: item.Custom,
                        rotina: item.Rotina,
                        permissoes: item.Permissoes,
                    };
                });
            });
            const merged = [].concat.apply([], permissoes).flat();
            this.localStorage.setItem("permissoes", JSON.stringify(merged));
        });
    }
    ngOnInit() {
        this.permissoes.PermiteAlterar = false;
        this.permissoes.PermiteExcluirFilhos = true;
        this.permissoes.PermiteExcluir = true;
        this.atualizarMenus();
    }
    rotaAlterada(componente) {
        if (componente.logado) {
            componente.logado.subscribe((atualiza) => {
                this.atualizarMenus();
            });
        }
    }
};
AppComponent.ctorParameters = () => [
    { type: dtp_angular_library__WEBPACK_IMPORTED_MODULE_2__["AuthService"] },
    { type: dtp_angular_library__WEBPACK_IMPORTED_MODULE_2__["CustomLocalStorageService"] },
    { type: dtp_angular_library__WEBPACK_IMPORTED_MODULE_2__["DropDownMenuService"] },
    { type: src_app_uboi_base_services_jbs_mfa_token_service__WEBPACK_IMPORTED_MODULE_3__["MfaTokenService"] }
];
AppComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "dtp-root",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./app.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./app.component.css */ "./src/app/app.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [dtp_angular_library__WEBPACK_IMPORTED_MODULE_2__["AuthService"],
        dtp_angular_library__WEBPACK_IMPORTED_MODULE_2__["CustomLocalStorageService"],
        dtp_angular_library__WEBPACK_IMPORTED_MODULE_2__["DropDownMenuService"],
        src_app_uboi_base_services_jbs_mfa_token_service__WEBPACK_IMPORTED_MODULE_3__["MfaTokenService"]])
], AppComponent);



/***/ }),

/***/ "./src/app/app.module.ts":
/*!*******************************!*\
  !*** ./src/app/app.module.ts ***!
  \*******************************/
/*! exports provided: AppModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppModule", function() { return AppModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _uboi_componentes_componentes_module__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./uboi/componentes/componentes.module */ "./src/app/uboi/componentes/componentes.module.ts");
/* harmony import */ var _uboi_uboi_module__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./uboi/uboi.module */ "./src/app/uboi/uboi.module.ts");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _app_routing_module__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./app-routing.module */ "./src/app/app-routing.module.ts");
/* harmony import */ var _app_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./app.component */ "./src/app/app.component.ts");
/* harmony import */ var _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/platform-browser/animations */ "./node_modules/@angular/platform-browser/fesm2015/animations.js");
/* harmony import */ var dtp_angular_library__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! dtp-angular-library */ "./node_modules/dtp-angular-library/fesm2015/dtp-angular-library.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _angular_common_locales_pt__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @angular/common/locales/pt */ "./node_modules/@angular/common/locales/pt.js");
/* harmony import */ var _angular_common_locales_pt__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_angular_common_locales_pt__WEBPACK_IMPORTED_MODULE_9__);








// teste


Object(_angular_common__WEBPACK_IMPORTED_MODULE_8__["registerLocaleData"])(_angular_common_locales_pt__WEBPACK_IMPORTED_MODULE_9___default.a);
let AppModule = class AppModule {
};
AppModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_3__["NgModule"])({
        declarations: [
            _app_component__WEBPACK_IMPORTED_MODULE_5__["AppComponent"]
        ],
        imports: [
            _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_6__["BrowserAnimationsModule"],
            _app_routing_module__WEBPACK_IMPORTED_MODULE_4__["AppRoutingModule"],
            dtp_angular_library__WEBPACK_IMPORTED_MODULE_7__["DtpAngularLibraryModule"],
            _uboi_uboi_module__WEBPACK_IMPORTED_MODULE_2__["UboiModule"],
            _uboi_componentes_componentes_module__WEBPACK_IMPORTED_MODULE_1__["ComponentesModule"]
        ],
        providers: [
            { provide: _angular_core__WEBPACK_IMPORTED_MODULE_3__["LOCALE_ID"], useValue: 'pt-BR' }
        ],
        bootstrap: [_app_component__WEBPACK_IMPORTED_MODULE_5__["AppComponent"]]
    })
], AppModule);



/***/ }),

/***/ "./src/app/uboi/base/models/jbs-admin-mfa-token-model.ts":
/*!***************************************************************!*\
  !*** ./src/app/uboi/base/models/jbs-admin-mfa-token-model.ts ***!
  \***************************************************************/
/*! exports provided: JbsAdminMfaTokenModel */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JbsAdminMfaTokenModel", function() { return JbsAdminMfaTokenModel; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

class JbsAdminMfaTokenModel {
}


/***/ }),

/***/ "./src/app/uboi/base/models/jbs-admin-mfa-token.ts":
/*!*********************************************************!*\
  !*** ./src/app/uboi/base/models/jbs-admin-mfa-token.ts ***!
  \*********************************************************/
/*! exports provided: JbsAdminMfaToken */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JbsAdminMfaToken", function() { return JbsAdminMfaToken; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var dtp_angular_library__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! dtp-angular-library */ "./node_modules/dtp-angular-library/fesm2015/dtp-angular-library.js");


class JbsAdminMfaToken extends dtp_angular_library__WEBPACK_IMPORTED_MODULE_1__["ModelBase"] {
    addKeys() {
        this.keys.push("token");
    }
    toModel(jsonData) {
        return Object.assign(new JbsAdminMfaToken(), jsonData, { keys: this.keys });
    }
    modelConfiguration() {
        this.modelDisplay = "Analista";
    }
}


/***/ }),

/***/ "./src/app/uboi/base/models/jbs-parametro.ts":
/*!***************************************************!*\
  !*** ./src/app/uboi/base/models/jbs-parametro.ts ***!
  \***************************************************/
/*! exports provided: JbsParametro */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JbsParametro", function() { return JbsParametro; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var dtp_angular_library__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! dtp-angular-library */ "./node_modules/dtp-angular-library/fesm2015/dtp-angular-library.js");


class JbsParametro extends dtp_angular_library__WEBPACK_IMPORTED_MODULE_1__["ModelBase"] {
    addKeys() {
        this.keys.push("Nome");
    }
    toModel(jsonData) {
        return Object.assign(new JbsParametro(), jsonData, { keys: this.keys });
    }
    modelConfiguration() {
        this.modelDisplay = 'Parametro';
        this.alphanumericKey = true;
    }
}


/***/ }),

/***/ "./src/app/uboi/base/services/jbs-mfa-token.service.ts":
/*!*************************************************************!*\
  !*** ./src/app/uboi/base/services/jbs-mfa-token.service.ts ***!
  \*************************************************************/
/*! exports provided: MfaTokenService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MfaTokenService", function() { return MfaTokenService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _models_jbs_admin_mfa_token__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./../models/jbs-admin-mfa-token */ "./src/app/uboi/base/models/jbs-admin-mfa-token.ts");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var dtp_angular_library__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! dtp-angular-library */ "./node_modules/dtp-angular-library/fesm2015/dtp-angular-library.js");





let MfaTokenService = class MfaTokenService extends dtp_angular_library__WEBPACK_IMPORTED_MODULE_4__["RelatedServiceBase"] {
    constructor(injector) {
        super("JbsAdminMfaToken", injector, _models_jbs_admin_mfa_token__WEBPACK_IMPORTED_MODULE_2__["JbsAdminMfaToken"]);
        this.injector = injector;
    }
    MfaLogin(model) {
        const url = this.config.Configuracoes().urlApi + "Token/mfa-login";
        const headers = new _angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpHeaders"]();
        const formData = new FormData();
        formData.append("hashcode", model.hashcode);
        formData.append("token", model.token);
        return this.http.post(url, formData);
    }
    ResendMfaLogin(hashcode) {
        const url = `${this.config.Configuracoes().urlApi}Token/resend-mfa-token/${hashcode}`;
        return this.http.post(url, null);
    }
    ObterToken(usuario) {
        const url = this.config.Configuracoes().urlApi + "Token/mfa-token";
        const headers = new _angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpHeaders"]();
        const formData = new FormData();
        formData.append("userName", usuario.Login);
        formData.append("password", usuario.Senha);
        if (usuario.hashCaptcha != null) {
            formData.append("hashCaptcha", usuario.hashCaptcha);
        }
        return this.http.post(url, formData);
    }
    Autenticado(isTrue) {
        return isTrue ? isTrue : false;
    }
};
MfaTokenService.ctorParameters = () => [
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_3__["Injector"] }
];
MfaTokenService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_3__["Injectable"])({
        providedIn: "root",
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_core__WEBPACK_IMPORTED_MODULE_3__["Injector"]])
], MfaTokenService);



/***/ }),

/***/ "./src/app/uboi/base/services/jbs-parametro.service.ts":
/*!*************************************************************!*\
  !*** ./src/app/uboi/base/services/jbs-parametro.service.ts ***!
  \*************************************************************/
/*! exports provided: JbsParametroService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JbsParametroService", function() { return JbsParametroService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var dtp_angular_library__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! dtp-angular-library */ "./node_modules/dtp-angular-library/fesm2015/dtp-angular-library.js");
/* harmony import */ var _models_jbs_parametro__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../models/jbs-parametro */ "./src/app/uboi/base/models/jbs-parametro.ts");




let JbsParametroService = class JbsParametroService extends dtp_angular_library__WEBPACK_IMPORTED_MODULE_2__["RelatedServiceBase"] {
    constructor(injector) {
        super('JbsParametro', injector, _models_jbs_parametro__WEBPACK_IMPORTED_MODULE_3__["JbsParametro"]);
        this.injector = injector;
    }
};
JbsParametroService.ctorParameters = () => [
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Injector"] }
];
JbsParametroService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injector"]])
], JbsParametroService);



/***/ }),

/***/ "./src/app/uboi/componentes/componentes.module.ts":
/*!********************************************************!*\
  !*** ./src/app/uboi/componentes/componentes.module.ts ***!
  \********************************************************/
/*! exports provided: ComponentesModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ComponentesModule", function() { return ComponentesModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var dtp_angular_library__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! dtp-angular-library */ "./node_modules/dtp-angular-library/fesm2015/dtp-angular-library.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _jbs_navside_jbs_navside_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./jbs-navside/jbs-navside.component */ "./src/app/uboi/componentes/jbs-navside/jbs-navside.component.ts");






let ComponentesModule = class ComponentesModule {
};
ComponentesModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_3__["NgModule"])({
        declarations: [_jbs_navside_jbs_navside_component__WEBPACK_IMPORTED_MODULE_5__["JbsNavsideComponent"]],
        exports: [_jbs_navside_jbs_navside_component__WEBPACK_IMPORTED_MODULE_5__["JbsNavsideComponent"]],
        imports: [_angular_common__WEBPACK_IMPORTED_MODULE_4__["CommonModule"], dtp_angular_library__WEBPACK_IMPORTED_MODULE_2__["DtpAngularLibraryModule"], _angular_router__WEBPACK_IMPORTED_MODULE_1__["RouterModule"]]
    })
], ComponentesModule);



/***/ }),

/***/ "./src/app/uboi/componentes/jbs-navside/jbs-navside.component.css":
/*!************************************************************************!*\
  !*** ./src/app/uboi/componentes/jbs-navside/jbs-navside.component.css ***!
  \************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".main-menu {\n  position: fixed;\n  z-index: 1021;\n  width: 70px;\n  padding: 10px 5px 0px;\n\n  height: 100%;\n  transition: width 0.2s linear;\n  box-shadow: 3px 0 30px 0 rgba(0, 0, 0, 0.1);\n  background-color: #ffffff;\n\n  /* display: flex; */\n  /* flex-direction: column; */\n}\n\n/* BOTÃO EXPANDIR */\n\n.expand {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  border: none;\n  background-color: #ffffff;\n  margin: auto;\n  margin-top: 8px;\n  outline: none;\n  transition: 0.2s all;\n}\n\n.expand:hover {\n  background-color: #cccccc;\n}\n\n/* .expand:hover .fa {\n    color: #fff;\n  } */\n\n.expand .fa {\n  display: inline;\n  width: auto;\n  height: auto;\n  font-size: 2rem;\n  color: #707070;\n  transition: 0.2s all;\n}\n\n.expanded .expand {\n  width: 100%;\n  border-radius: unset;\n  display: flex;\n}\n\n.expanded .expand > .icon {\n  width: 70px;\n  height: 40px;\n  line-height: 40px;\n  text-align: center;\n}\n\n.expand > span.title-button {\n  display: none;\n}\n\n.expanded .expand > span.title-button {\n  display: inline-block;\n  flex: 1;\n  text-align: left;\n  margin-left: 15px;\n\n  font-size: 14px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.36;\n  letter-spacing: normal;\n  text-align: left;\n  color: #707070;\n  height: 40px;\n  line-height: 38px;\n}\n\n.expanded button:hover.expand > span.title-button,\n.expanded a:hover.expand > span.title-button {\n  font-weight: bold;\n}\n\n/*ESTILIZAÇÃO ICONES*/\n\n.fa-2x {\n  font-size: 2.5em;\n}\n\n.fa {\n  position: relative;\n  display: flex;\n  width: 24px;\n  height: 24px;\n  justify-content: center;\n  align-items: center;\n  font-size: 1.5em;\n}\n\n/*LISTA DE ITENS*/\n\n.main-menu > ul {\n  padding: 1rem 0 0rem;\n}\n\n.main-menu li {\n  position: relative;\n  display: block;\n}\n\n.main-menu li > a {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  width: 60px;\n  height: 60px;\n  margin-bottom: 20px;\n\n  position: relative;\n  line-height: 1;\n  text-decoration: none;\n  transform: translateZ(0) scale(1, 1);\n  transition: 0.3s width;\n\n  background-color: var(--cor-primaria);\n  border-radius: 10px;\n}\n\n.main-menu li > a:hover {\n  width: 300px;\n  justify-content: flex-start;\n  z-index: 1;\n}\n\n.main-menu li > a:hover .nav-text {\n  opacity: 1;\n  color: #fff;\n  width: 205px;\n  white-space: normal;\n  margin-left: 25px;\n}\n\n.limit-nav-text {\n  display: -webkit-box !important;\n  -webkit-box-orient: vertical;\n  -ms-box-orient: vertical;\n  box-orient: vertical;\n\n  -webkit-line-clamp: 2;\n  -moz-line-clamp: 2;\n  -ms-line-clamp: 2;\n  line-clamp: 2;\n\n  overflow: hidden !important;\n  text-overflow: ellipsis !important;\n  word-break: break-word;\n}\n\n.main-menu li > a .nav-icon ::ng-deep i {\n  color: #fff !important;\n  font-size: 1em;\n  line-height: 60px;\n  font-style: normal;\n}\n\n.main-menu li > a .nav-icon {\n  position: relative;\n  border-radius: 10px;\n  width: 60px;\n  height: 60px;\n}\n\n.main-menu li > a .nav-text {\n  font-size: 0.875em;\n  font-weight: 600;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.4;\n  letter-spacing: normal;\n  text-align: left;\n  color: var(--cor-primaria);\n}\n\n.container-icon {\n  width: 60px;\n  height: 60px;\n}\n\n.main-menu > ul.logout {\n  position: absolute;\n  left: 0;\n  bottom: 0;\n}\n\n.no-touch .scrollable.hover {\n  overflow-y: hidden;\n}\n\n.no-touch .scrollable.hover:hover {\n  overflow-y: auto;\n  overflow: visible;\n}\n\na:hover,\na:focus {\n  text-decoration: none;\n}\n\nnav {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  -o-user-select: none;\n  user-select: none;\n}\n\nnav ul,\nnav li {\n  outline: 0;\n  margin: 0;\n  padding: 0;\n}\n\n.area {\n  float: left;\n  background: #e2e2e2;\n  width: 100%;\n  height: 100%;\n}\n\n/*ESTILIZAÇÃO LISTA EXPANDIDA*/\n\nnav.main-menu.expanded {\n  width: 240px;\n  padding: 10px 0px 0px;\n\n  overflow: visible;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\nnav.main-menu.expanded:after {\n  content: none;\n}\n\nnav.main-menu.expanded .favorite-button {\n  margin-bottom: 15rem;\n}\n\nnav.main-menu.expanded li > a {\n  width: 100%;\n  background-color: transparent;\n  transition: background-color 0.3s;\n  border-radius: 0;\n  padding: 0px 6px;\n}\n\nnav.main-menu.expanded li > a .nav-text {\n  opacity: 1;\n  white-space: normal;\n  margin-right: 10px;\n  margin-left: 15px;\n  flex: 1;\n}\n\nnav.main-menu.expanded li > a:hover {\n  background-color: var(--cor-primaria);\n}\n\nnav.main-menu.expanded li > a .nav-icon {\n  background: var(--cor-primaria);\n}\n\nnav.main-menu.expanded .bottom-buttons {\n  /* position: fixed; */\n  /* width: 240px; */\n  width: 100%;\n  position: -webkit-sticky;\n  position: sticky;\n}\n\n.container-button-expand {\n  height: 52px;\n}\n\nnav.main-menu.expanded .container-icon {\n  width: 70px;\n  padding: 0px 15px;\n}\n\n.bottom-buttons ::ng-deep .link {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 20px;\n  width: 40px;\n  height: 40px;\n  border: none;\n  background-color: #ffffff;\n  margin: auto;\n  margin-top: 8px;\n  outline: none;\n  transition: 0.2s all;\n}\n\n.bottom-buttons ::ng-deep .link:hover {\n  background-color: #cccccc;\n  text-decoration: none;\n}\n\n.bottom-buttons ::ng-deep .link .fa {\n  display: inline;\n  width: auto;\n  height: auto;\n  font-size: 2rem;\n  color: #707070;\n  transition: 0.2s all;\n}\n\n.expanded .bottom-buttons ::ng-deep .link {\n  width: 100%;\n  border-radius: unset;\n  display: flex;\n  padding: 0px 6px;\n}\n\n.bottom-buttons ::ng-deep .link > span.title-button {\n  display: none;\n}\n\n.expanded .bottom-buttons ::ng-deep .link > span.title-button {\n  display: inline-block;\n  flex: 1;\n  text-align: left;\n  margin-left: 15px;\n\n  font-size: 14px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.36;\n  letter-spacing: normal;\n  text-align: left;\n  color: #707070;\n  height: 40px;\n  line-height: 38px;\n}\n\n.expanded .bottom-buttons ::ng-deep button:hover.link > span.title-button,\n.expanded .bottom-buttons ::ng-deep a:hover.link > span.title-button {\n  font-weight: bold;\n}\n\n.expanded .bottom-buttons ::ng-deep .link:hover {\n  background-color: #cccccc;\n}\n\n/* nav.main-menu.expanded .container-icon {\n    width: 70px;\n    padding: 0px 15px;\n  } */\n\n.expanded .bottom-buttons ::ng-deep .link > .icon {\n  width: 70px;\n  height: 40px;\n  line-height: 40px;\n  text-align: center;\n}\n\n.bottom-buttons ::ng-deep .link-yellow {\n  color: #ffb100 !important;\n}\n\n.container-arrow-icon {\n  display: none;\n}\n\n.main-menu li > a:hover .container-arrow-icon {\n  display: inline-block;\n}\n\n.container-button-favorite {\n  flex: 1;\n}\n\n.nowrap {\n  white-space: nowrap !important;\n}\n\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/uboi/componentes/jbs-navside/jbs-navside.component.ts":
/*!***********************************************************************!*\
  !*** ./src/app/uboi/componentes/jbs-navside/jbs-navside.component.ts ***!
  \***********************************************************************/
/*! exports provided: JbsNavsideComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JbsNavsideComponent", function() { return JbsNavsideComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var dtp_angular_library__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! dtp-angular-library */ "./node_modules/dtp-angular-library/fesm2015/dtp-angular-library.js");



let JbsNavsideComponent = class JbsNavsideComponent {
    constructor() {
        this.expanded = false;
    }
    onEvent(event) {
        event.stopPropagation();
    }
    onClick() {
        this.expanded = false;
    }
    ngOnInit() {
    }
};
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", dtp_angular_library__WEBPACK_IMPORTED_MODULE_2__["DropDownMenu"])
], JbsNavsideComponent.prototype, "menus", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", String)
], JbsNavsideComponent.prototype, "routerFavoriteLink", void 0);
JbsNavsideComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'jbs-navside',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./jbs-navside.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/uboi/componentes/jbs-navside/jbs-navside.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./jbs-navside.component.css */ "./src/app/uboi/componentes/jbs-navside/jbs-navside.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [])
], JbsNavsideComponent);



/***/ }),

/***/ "./src/app/uboi/core/autorizacao/autorizacao.module.ts":
/*!*************************************************************!*\
  !*** ./src/app/uboi/core/autorizacao/autorizacao.module.ts ***!
  \*************************************************************/
/*! exports provided: AutorizacaoModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AutorizacaoModule", function() { return AutorizacaoModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var dtp_angular_library__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! dtp-angular-library */ "./node_modules/dtp-angular-library/fesm2015/dtp-angular-library.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _login_login_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./login/login.component */ "./src/app/uboi/core/autorizacao/login/login.component.ts");
/* harmony import */ var _componentes_componentes_module__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../componentes/componentes.module */ "./src/app/uboi/componentes/componentes.module.ts");
/* harmony import */ var ng_recaptcha__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ng-recaptcha */ "./node_modules/ng-recaptcha/fesm2015/ng-recaptcha.js");
/* harmony import */ var _two_factor_two_factor_component__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./two-factor/two-factor.component */ "./src/app/uboi/core/autorizacao/two-factor/two-factor.component.ts");









let AutorizacaoModule = class AutorizacaoModule {
};
AutorizacaoModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_3__["NgModule"])({
        declarations: [_login_login_component__WEBPACK_IMPORTED_MODULE_5__["LoginComponent"], _two_factor_two_factor_component__WEBPACK_IMPORTED_MODULE_8__["TwoFactorComponent"]],
        exports: [_login_login_component__WEBPACK_IMPORTED_MODULE_5__["LoginComponent"], _two_factor_two_factor_component__WEBPACK_IMPORTED_MODULE_8__["TwoFactorComponent"]],
        imports: [
            _angular_common__WEBPACK_IMPORTED_MODULE_4__["CommonModule"],
            dtp_angular_library__WEBPACK_IMPORTED_MODULE_2__["DtpAngularLibraryModule"],
            _componentes_componentes_module__WEBPACK_IMPORTED_MODULE_6__["ComponentesModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_1__["FormsModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_1__["ReactiveFormsModule"],
            ng_recaptcha__WEBPACK_IMPORTED_MODULE_7__["RecaptchaModule"],
        ],
    })
], AutorizacaoModule);



/***/ }),

/***/ "./src/app/uboi/core/autorizacao/login/login.component.css":
/*!*****************************************************************!*\
  !*** ./src/app/uboi/core/autorizacao/login/login.component.css ***!
  \*****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".box-login {\n  max-width: 460px;\n  width: 100%;\n  padding: 0 1rem;\n  margin: auto;\n}\n\n.loginmodal-container {\n  padding: 30px;\n  width: 100% !important;\n  background-color: #f7f7f7;\n  margin: 0 auto;\n  border-radius: 2px;\n  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);\n  overflow: hidden;\n  margin-top: 10em;\n}\n\n.loginmodal-container h3 {\n  text-align: center;\n  font-size: 1.8em;\n}\n\nre-captcha {\n  display: flex;\n  justify-content: center;\n}\n\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvdWJvaS9jb3JlL2F1dG9yaXphY2FvL2xvZ2luL2xvZ2luLmNvbXBvbmVudC5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxnQkFBZ0I7RUFDaEIsV0FBVztFQUNYLGVBQWU7RUFDZixZQUFZO0FBQ2Q7O0FBRUE7RUFDRSxhQUFhO0VBQ2Isc0JBQXNCO0VBQ3RCLHlCQUF5QjtFQUN6QixjQUFjO0VBQ2Qsa0JBQWtCO0VBQ2xCLDBDQUEwQztFQUMxQyxnQkFBZ0I7RUFDaEIsZ0JBQWdCO0FBQ2xCOztBQUVBO0VBQ0Usa0JBQWtCO0VBQ2xCLGdCQUFnQjtBQUNsQjs7QUFFQTtFQUNFLGFBQWE7RUFDYix1QkFBdUI7QUFDekIiLCJmaWxlIjoic3JjL2FwcC91Ym9pL2NvcmUvYXV0b3JpemFjYW8vbG9naW4vbG9naW4uY29tcG9uZW50LmNzcyIsInNvdXJjZXNDb250ZW50IjpbIi5ib3gtbG9naW4ge1xuICBtYXgtd2lkdGg6IDQ2MHB4O1xuICB3aWR0aDogMTAwJTtcbiAgcGFkZGluZzogMCAxcmVtO1xuICBtYXJnaW46IGF1dG87XG59XG5cbi5sb2dpbm1vZGFsLWNvbnRhaW5lciB7XG4gIHBhZGRpbmc6IDMwcHg7XG4gIHdpZHRoOiAxMDAlICFpbXBvcnRhbnQ7XG4gIGJhY2tncm91bmQtY29sb3I6ICNmN2Y3Zjc7XG4gIG1hcmdpbjogMCBhdXRvO1xuICBib3JkZXItcmFkaXVzOiAycHg7XG4gIGJveC1zaGFkb3c6IDBweCAycHggMnB4IHJnYmEoMCwgMCwgMCwgMC4zKTtcbiAgb3ZlcmZsb3c6IGhpZGRlbjtcbiAgbWFyZ2luLXRvcDogMTBlbTtcbn1cblxuLmxvZ2lubW9kYWwtY29udGFpbmVyIGgzIHtcbiAgdGV4dC1hbGlnbjogY2VudGVyO1xuICBmb250LXNpemU6IDEuOGVtO1xufVxuXG5yZS1jYXB0Y2hhIHtcbiAgZGlzcGxheTogZmxleDtcbiAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG59XG4iXX0= */");

/***/ }),

/***/ "./src/app/uboi/core/autorizacao/login/login.component.ts":
/*!****************************************************************!*\
  !*** ./src/app/uboi/core/autorizacao/login/login.component.ts ***!
  \****************************************************************/
/*! exports provided: LoginComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LoginComponent", function() { return LoginComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var dtp_angular_library__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! dtp-angular-library */ "./node_modules/dtp-angular-library/fesm2015/dtp-angular-library.js");
/* harmony import */ var angular_notifier__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! angular-notifier */ "./node_modules/angular-notifier/fesm2015/angular-notifier.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var ng_recaptcha__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ng-recaptcha */ "./node_modules/ng-recaptcha/fesm2015/ng-recaptcha.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var src_app_uboi_base_services_jbs_mfa_token_service__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! src/app/uboi/base/services/jbs-mfa-token.service */ "./src/app/uboi/base/services/jbs-mfa-token.service.ts");









let LoginComponent = class LoginComponent {
    constructor(auth, formBuilder, router, notifier, localStorage, mfaLogin) {
        this.auth = auth;
        this.formBuilder = formBuilder;
        this.router = router;
        this.notifier = notifier;
        this.localStorage = localStorage;
        this.mfaLogin = mfaLogin;
        this.token = null;
        this.expirado = false;
        this.usuario = new dtp_angular_library__WEBPACK_IMPORTED_MODULE_2__["Usuario"]();
        this.notifier = notifier;
        this.siteKey = window.config.recaptchaSiteKey;
        if (this.router.getCurrentNavigation().extras.state) {
            if (this.router.getCurrentNavigation().extras.state.expired) {
                this.expirado = true;
            }
        }
    }
    ngOnInit() {
        if (this.localStorage.existeChave("auth")) {
            this.router.navigate(["inicio"]);
        }
        this.formPasswordReset = this.formBuilder.group({
            password: ["", [_angular_forms__WEBPACK_IMPORTED_MODULE_5__["Validators"].required, _angular_forms__WEBPACK_IMPORTED_MODULE_5__["Validators"].minLength(8)]],
            password_repeat: ["", [_angular_forms__WEBPACK_IMPORTED_MODULE_5__["Validators"].required]],
        }, { validator: this.checkPasswords });
        console.log("started");
    }
    ValidarLogin() {
        if (this.captcha) {
            this.captcha.execute();
        }
        else {
            this.Login(null);
        }
    }
    Login(event) {
        this.usuario.hashCaptcha = event;
        this.localStorage.setItem("userName", this.usuario.Login);
        this.localStorage.setItem("password", this.usuario.Senha);
        this.mfaLogin
            .ObterToken(this.usuario)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_7__["map"])((response) => response.hashcode))
            .subscribe((hashcode) => {
            this.router.navigate(["/two-factor-auth"], {
                queryParams: { hashcode: hashcode },
            });
        }, (erro) => {
            if (erro.error.passwordReset) {
                this.token = erro.error.access_token;
                this.OpenPasswordReset();
            }
            else {
                this.usuario.hashCaptcha = null;
                if (this.captcha) {
                    this.captcha.reset();
                }
                this.notifier.notify("error", typeof erro.error == "string"
                    ? erro.error
                    : "Ocorreu um erro, mais informações no console.");
                if (typeof erro.error !== "string") {
                    console.error("ERRO => ", erro);
                }
            }
        });
        return false;
    }
    checkPasswords(group) {
        const pass = group.get("password").value;
        const confirmPass = group.get("password_repeat").value;
        if (pass === confirmPass) {
            if (confirmPass === "") {
                group.get("password_repeat").setErrors({ required: true });
            }
            else {
                group.get("password_repeat").setErrors(null);
            }
        }
        else {
            group
                .get("password_repeat")
                .setErrors({ required: confirmPass === "", passwordConfirm: true });
        }
    }
    OpenPasswordReset() {
        this.modalPasswordReset.abrir();
    }
    SavePasswordReset() {
        this.usuario.Senha = this.formPasswordReset.get("password").value;
        this.usuario.ConfirmaSenha =
            this.formPasswordReset.get("password_repeat").value;
        this.auth.ResetarSenha(this.usuario, this.token).subscribe((data) => {
            if (data === 1) {
                this.modalPasswordReset.fechar();
                this.notifier.notify("success", "Senha redefinida com sucesso! Faça o login para acessar.");
            }
        }, (err) => {
            this.notifier.notify("error", typeof err.error == "string"
                ? err.error
                : "Ocorreu um erro, mais informações no console.");
            if (typeof err.error !== "string") {
                console.error("ERRO => ", err);
            }
        });
    }
};
LoginComponent.ctorParameters = () => [
    { type: dtp_angular_library__WEBPACK_IMPORTED_MODULE_2__["AuthService"] },
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_5__["FormBuilder"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_4__["Router"] },
    { type: angular_notifier__WEBPACK_IMPORTED_MODULE_3__["NotifierService"] },
    { type: dtp_angular_library__WEBPACK_IMPORTED_MODULE_2__["CustomLocalStorageService"] },
    { type: src_app_uboi_base_services_jbs_mfa_token_service__WEBPACK_IMPORTED_MODULE_8__["MfaTokenService"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])("modalPasswordReset", { static: true }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", dtp_angular_library__WEBPACK_IMPORTED_MODULE_2__["GenericModalComponent"])
], LoginComponent.prototype, "modalPasswordReset", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])("reCaptcha", { static: false }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", ng_recaptcha__WEBPACK_IMPORTED_MODULE_6__["RecaptchaComponent"])
], LoginComponent.prototype, "captcha", void 0);
LoginComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "dtp-login",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./login.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/uboi/core/autorizacao/login/login.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./login.component.css */ "./src/app/uboi/core/autorizacao/login/login.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [dtp_angular_library__WEBPACK_IMPORTED_MODULE_2__["AuthService"],
        _angular_forms__WEBPACK_IMPORTED_MODULE_5__["FormBuilder"],
        _angular_router__WEBPACK_IMPORTED_MODULE_4__["Router"],
        angular_notifier__WEBPACK_IMPORTED_MODULE_3__["NotifierService"],
        dtp_angular_library__WEBPACK_IMPORTED_MODULE_2__["CustomLocalStorageService"],
        src_app_uboi_base_services_jbs_mfa_token_service__WEBPACK_IMPORTED_MODULE_8__["MfaTokenService"]])
], LoginComponent);



/***/ }),

/***/ "./src/app/uboi/core/autorizacao/two-factor/two-factor.component.css":
/*!***************************************************************************!*\
  !*** ./src/app/uboi/core/autorizacao/two-factor/two-factor.component.css ***!
  \***************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".box-login {\n  max-width: 460px;\n  width: 100%;\n  padding: 0 1rem;\n  margin: auto;\n\n  img {\n    max-width: 100%;\n  }\n}\n\n.loginmodal-container {\n  padding: 30px;\n  width: 100% !important;\n  background-color: #f7f7f7;\n  margin: 0 auto;\n  border-radius: 2px;\n  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);\n  overflow: hidden;\n  margin-top: 10em;\n}\n\n.loginmodal-container h3 {\n  text-align: center;\n  font-size: 1.8em;\n}\n\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvdWJvaS9jb3JlL2F1dG9yaXphY2FvL3R3by1mYWN0b3IvdHdvLWZhY3Rvci5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsZ0JBQWdCO0VBQ2hCLFdBQVc7RUFDWCxlQUFlO0VBQ2YsWUFBWTs7RUFFWjtJQUNFLGVBQWU7RUFDakI7QUFDRjs7QUFFQTtFQUNFLGFBQWE7RUFDYixzQkFBc0I7RUFDdEIseUJBQXlCO0VBQ3pCLGNBQWM7RUFDZCxrQkFBa0I7RUFDbEIsMENBQTBDO0VBQzFDLGdCQUFnQjtFQUNoQixnQkFBZ0I7QUFDbEI7O0FBRUE7RUFDRSxrQkFBa0I7RUFDbEIsZ0JBQWdCO0FBQ2xCIiwiZmlsZSI6InNyYy9hcHAvdWJvaS9jb3JlL2F1dG9yaXphY2FvL3R3by1mYWN0b3IvdHdvLWZhY3Rvci5jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLmJveC1sb2dpbiB7XG4gIG1heC13aWR0aDogNDYwcHg7XG4gIHdpZHRoOiAxMDAlO1xuICBwYWRkaW5nOiAwIDFyZW07XG4gIG1hcmdpbjogYXV0bztcblxuICBpbWcge1xuICAgIG1heC13aWR0aDogMTAwJTtcbiAgfVxufVxuXG4ubG9naW5tb2RhbC1jb250YWluZXIge1xuICBwYWRkaW5nOiAzMHB4O1xuICB3aWR0aDogMTAwJSAhaW1wb3J0YW50O1xuICBiYWNrZ3JvdW5kLWNvbG9yOiAjZjdmN2Y3O1xuICBtYXJnaW46IDAgYXV0bztcbiAgYm9yZGVyLXJhZGl1czogMnB4O1xuICBib3gtc2hhZG93OiAwcHggMnB4IDJweCByZ2JhKDAsIDAsIDAsIDAuMyk7XG4gIG92ZXJmbG93OiBoaWRkZW47XG4gIG1hcmdpbi10b3A6IDEwZW07XG59XG5cbi5sb2dpbm1vZGFsLWNvbnRhaW5lciBoMyB7XG4gIHRleHQtYWxpZ246IGNlbnRlcjtcbiAgZm9udC1zaXplOiAxLjhlbTtcbn1cbiJdfQ== */");

/***/ }),

/***/ "./src/app/uboi/core/autorizacao/two-factor/two-factor.component.ts":
/*!**************************************************************************!*\
  !*** ./src/app/uboi/core/autorizacao/two-factor/two-factor.component.ts ***!
  \**************************************************************************/
/*! exports provided: TwoFactorComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TwoFactorComponent", function() { return TwoFactorComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var dtp_angular_library__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! dtp-angular-library */ "./node_modules/dtp-angular-library/fesm2015/dtp-angular-library.js");
/* harmony import */ var angular_notifier__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! angular-notifier */ "./node_modules/angular-notifier/fesm2015/angular-notifier.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var ng_recaptcha__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ng-recaptcha */ "./node_modules/ng-recaptcha/fesm2015/ng-recaptcha.js");
/* harmony import */ var src_app_uboi_base_services_jbs_mfa_token_service__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! src/app/uboi/base/services/jbs-mfa-token.service */ "./src/app/uboi/base/services/jbs-mfa-token.service.ts");
/* harmony import */ var src_app_uboi_base_models_jbs_admin_mfa_token__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! src/app/uboi/base/models/jbs-admin-mfa-token */ "./src/app/uboi/base/models/jbs-admin-mfa-token.ts");
/* harmony import */ var src_app_uboi_base_models_jbs_admin_mfa_token_model__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! src/app/uboi/base/models/jbs-admin-mfa-token-model */ "./src/app/uboi/base/models/jbs-admin-mfa-token-model.ts");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");












let TwoFactorComponent = class TwoFactorComponent {
    constructor(auth, formBuilder, router, notifier, localStorage, route, mfaLogin) {
        this.auth = auth;
        this.formBuilder = formBuilder;
        this.router = router;
        this.notifier = notifier;
        this.localStorage = localStorage;
        this.route = route;
        this.mfaLogin = mfaLogin;
        this.token = null;
        this.expirado = false;
        this.urlRedirect = "inicio";
        this.logado = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"]();
        this.usuario = new dtp_angular_library__WEBPACK_IMPORTED_MODULE_2__["Usuario"]();
        this.mfaToken = new src_app_uboi_base_models_jbs_admin_mfa_token_model__WEBPACK_IMPORTED_MODULE_9__["JbsAdminMfaTokenModel"]();
        this.mfaToken.token = "";
        this.notifier = notifier;
        this.siteKey = window.config.recaptchaSiteKey;
    }
    ngOnInit() {
        console.log("started");
        if (this.router.getCurrentNavigation().extras.state) {
            if (this.router.getCurrentNavigation().extras.state.expired) {
                this.expirado = true;
            }
            if (this.router.getCurrentNavigation().extras.state.urlRedirect) {
                this.urlRedirect =
                    this.router.getCurrentNavigation().extras.state.urlRedirect;
            }
        }
    }
    ValidarMfaLogin() {
        if (this.mfaToken.token.trim() === "") {
            this.notifier.notify("error", "Por favor, preencha o Token.");
        }
        else {
            this.route.queryParams.subscribe((params) => {
                this.mfaHashcode = params.hashcode;
            });
            const envioToken = new src_app_uboi_base_models_jbs_admin_mfa_token__WEBPACK_IMPORTED_MODULE_8__["JbsAdminMfaToken"]();
            envioToken.hashcode = this.mfaHashcode;
            envioToken.token = this.mfaToken.token;
            this.mfaLogin
                .MfaLogin(envioToken)
                .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_10__["map"])((response) => response))
                .subscribe((ret) => {
                this.usuario.Login = localStorage.getItem("userName");
                this.usuario.Senha = localStorage.getItem("password");
                this.auth.Autenticar(this.usuario).subscribe((ret) => {
                    this.router.navigateByUrl(this.urlRedirect);
                    this.logado.emit(true);
                });
                this.mfaLogin.Autenticado(true);
            }, (erro) => {
                this.notifier.notify("error", typeof erro.error == "string"
                    ? erro.error
                    : "Ocorreu um erro, mais informações no console.");
                if (typeof erro.error !== "string") {
                    console.error("ERRO => ", erro);
                }
            });
        }
    }
    ResendMfaToken() {
        this.route.queryParams.subscribe((params) => {
            this.mfaHashcode = params.hashcode;
        });
        this.mfaLogin
            .ResendMfaLogin(this.mfaHashcode)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_10__["map"])((response) => response.hashcode))
            .subscribe((hashcode) => {
            this.router.navigate(["/two-factor-auth"], {
                queryParams: { hashcode: hashcode },
            });
        }, (erro) => {
            this.notifier.notify("error", typeof erro.error == "string"
                ? erro.error
                : "Ocorreu um erro, mais informações no console.");
            if (typeof erro.error !== "string") {
                console.error("ERRO => ", erro);
            }
        });
    }
};
TwoFactorComponent.ctorParameters = () => [
    { type: dtp_angular_library__WEBPACK_IMPORTED_MODULE_2__["AuthService"] },
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_5__["FormBuilder"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_4__["Router"] },
    { type: angular_notifier__WEBPACK_IMPORTED_MODULE_3__["NotifierService"] },
    { type: dtp_angular_library__WEBPACK_IMPORTED_MODULE_2__["CustomLocalStorageService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_4__["ActivatedRoute"] },
    { type: src_app_uboi_base_services_jbs_mfa_token_service__WEBPACK_IMPORTED_MODULE_7__["MfaTokenService"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Output"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", Object)
], TwoFactorComponent.prototype, "logado", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])("modalPasswordReset", { static: true }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", dtp_angular_library__WEBPACK_IMPORTED_MODULE_2__["GenericModalComponent"])
], TwoFactorComponent.prototype, "modalPasswordReset", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])("reCaptcha", { static: false }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", ng_recaptcha__WEBPACK_IMPORTED_MODULE_6__["RecaptchaComponent"])
], TwoFactorComponent.prototype, "captcha", void 0);
TwoFactorComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: "dtp-login",
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./two-factor.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/uboi/core/autorizacao/two-factor/two-factor.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./two-factor.component.css */ "./src/app/uboi/core/autorizacao/two-factor/two-factor.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [dtp_angular_library__WEBPACK_IMPORTED_MODULE_2__["AuthService"],
        _angular_forms__WEBPACK_IMPORTED_MODULE_5__["FormBuilder"],
        _angular_router__WEBPACK_IMPORTED_MODULE_4__["Router"],
        angular_notifier__WEBPACK_IMPORTED_MODULE_3__["NotifierService"],
        dtp_angular_library__WEBPACK_IMPORTED_MODULE_2__["CustomLocalStorageService"],
        _angular_router__WEBPACK_IMPORTED_MODULE_4__["ActivatedRoute"],
        src_app_uboi_base_services_jbs_mfa_token_service__WEBPACK_IMPORTED_MODULE_7__["MfaTokenService"]])
], TwoFactorComponent);



/***/ }),

/***/ "./src/app/uboi/core/inicio/inicio.component.css":
/*!*******************************************************!*\
  !*** ./src/app/uboi/core/inicio/inicio.component.css ***!
  \*******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3Vib2kvY29yZS9pbmljaW8vaW5pY2lvLmNvbXBvbmVudC5jc3MifQ== */");

/***/ }),

/***/ "./src/app/uboi/core/inicio/inicio.component.ts":
/*!******************************************************!*\
  !*** ./src/app/uboi/core/inicio/inicio.component.ts ***!
  \******************************************************/
/*! exports provided: InicioComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InicioComponent", function() { return InicioComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let InicioComponent = class InicioComponent {
    constructor() { }
    ngOnInit() {
    }
};
InicioComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'dtp-inicio',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./inicio.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/uboi/core/inicio/inicio.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./inicio.component.css */ "./src/app/uboi/core/inicio/inicio.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [])
], InicioComponent);



/***/ }),

/***/ "./src/app/uboi/directives/DirectivesModule.ts":
/*!*****************************************************!*\
  !*** ./src/app/uboi/directives/DirectivesModule.ts ***!
  \*****************************************************/
/*! exports provided: DirectivesModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DirectivesModule", function() { return DirectivesModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var dtp_angular_library__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! dtp-angular-library */ "./node_modules/dtp-angular-library/fesm2015/dtp-angular-library.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _debounce_click_debounce_click_directive__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./debounce-click/debounce-click.directive */ "./src/app/uboi/directives/debounce-click/debounce-click.directive.ts");






let DirectivesModule = class DirectivesModule {
};
DirectivesModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_3__["NgModule"])({
        declarations: [_debounce_click_debounce_click_directive__WEBPACK_IMPORTED_MODULE_5__["DebounceClickDirective"]],
        exports: [_debounce_click_debounce_click_directive__WEBPACK_IMPORTED_MODULE_5__["DebounceClickDirective"]],
        imports: [_angular_common__WEBPACK_IMPORTED_MODULE_4__["CommonModule"], dtp_angular_library__WEBPACK_IMPORTED_MODULE_2__["DtpAngularLibraryModule"], _angular_router__WEBPACK_IMPORTED_MODULE_1__["RouterModule"]]
    })
], DirectivesModule);



/***/ }),

/***/ "./src/app/uboi/directives/debounce-click/debounce-click.directive.ts":
/*!****************************************************************************!*\
  !*** ./src/app/uboi/directives/debounce-click/debounce-click.directive.ts ***!
  \****************************************************************************/
/*! exports provided: DebounceClickDirective */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DebounceClickDirective", function() { return DebounceClickDirective; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");




let DebounceClickDirective = class DebounceClickDirective {
    constructor() {
        this.debounceTime = 500;
        this.debounceClick = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"]();
        this.clicks = new rxjs__WEBPACK_IMPORTED_MODULE_2__["Subject"]();
    }
    ngOnInit() {
        this.subscription = this.clicks.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["debounceTime"])(this.debounceTime)).subscribe(e => this.debounceClick.emit(e));
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
    clickEvent(event) {
        event.preventDefault();
        event.stopPropagation();
        this.clicks.next(event);
    }
};
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", Object)
], DebounceClickDirective.prototype, "debounceTime", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Output"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", Object)
], DebounceClickDirective.prototype, "debounceClick", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["HostListener"])('click', ['$event']),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", Function),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [Object]),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:returntype", void 0)
], DebounceClickDirective.prototype, "clickEvent", null);
DebounceClickDirective = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Directive"])({
        selector: '[appDebounceClick]'
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [])
], DebounceClickDirective);



/***/ }),

/***/ "./src/app/uboi/paginas/inicio/pagina-inicio.component.ts":
/*!****************************************************************!*\
  !*** ./src/app/uboi/paginas/inicio/pagina-inicio.component.ts ***!
  \****************************************************************/
/*! exports provided: PaginaInicioComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PaginaInicioComponent", function() { return PaginaInicioComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let PaginaInicioComponent = class PaginaInicioComponent {
    constructor() { }
    ngOnInit() {
    }
};
PaginaInicioComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'dtp-pagina-inicio',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./pagina-inicio.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/uboi/paginas/inicio/pagina-inicio.component.html")).default,
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [])
], PaginaInicioComponent);



/***/ }),

/***/ "./src/app/uboi/paginas/termos-contrato/termos-contrato-cadastro/termos-contrato-cadastro.component.css":
/*!**************************************************************************************************************!*\
  !*** ./src/app/uboi/paginas/termos-contrato/termos-contrato-cadastro/termos-contrato-cadastro.component.css ***!
  \**************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3Vib2kvcGFnaW5hcy90ZXJtb3MtY29udHJhdG8vdGVybW9zLWNvbnRyYXRvLWNhZGFzdHJvL3Rlcm1vcy1jb250cmF0by1jYWRhc3Ryby5jb21wb25lbnQuY3NzIn0= */");

/***/ }),

/***/ "./src/app/uboi/paginas/termos-contrato/termos-contrato-cadastro/termos-contrato-cadastro.component.ts":
/*!*************************************************************************************************************!*\
  !*** ./src/app/uboi/paginas/termos-contrato/termos-contrato-cadastro/termos-contrato-cadastro.component.ts ***!
  \*************************************************************************************************************/
/*! exports provided: TermosContratoCadastroComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TermosContratoCadastroComponent", function() { return TermosContratoCadastroComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _base_models_jbs_parametro__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./../../../base/models/jbs-parametro */ "./src/app/uboi/base/models/jbs-parametro.ts");
/* harmony import */ var _base_services_jbs_parametro_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./../../../base/services/jbs-parametro.service */ "./src/app/uboi/base/services/jbs-parametro.service.ts");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");





let TermosContratoCadastroComponent = class TermosContratoCadastroComponent {
    constructor(service, sanitizer) {
        this.service = service;
        this.sanitizer = sanitizer;
    }
    ngOnInit() {
        this.ObterContrato();
    }
    ObterContrato() {
        this.service.Obter().subscribe(itens => {
            if (itens.length > 0) {
                this.linkContrato = itens[0].Texto_aceite_contrato;
                this.pdfUrl();
            }
        });
    }
    SalvarAnexo(link) {
        console.log(link);
        let model = new _base_models_jbs_parametro__WEBPACK_IMPORTED_MODULE_1__["JbsParametro"]();
        model.Nome = "App uBoi";
        model.Texto_aceite_contrato = link[0].urlimg;
        this.service.Salvar(model, true).subscribe(item => {
            this.linkContrato = link[0].urlimg;
            this.pdfUrl();
        });
    }
    ;
    pdfUrl() {
        this.linkTratado = this.sanitizer.bypassSecurityTrustResourceUrl(this.linkContrato);
    }
};
TermosContratoCadastroComponent.ctorParameters = () => [
    { type: _base_services_jbs_parametro_service__WEBPACK_IMPORTED_MODULE_2__["JbsParametroService"] },
    { type: _angular_platform_browser__WEBPACK_IMPORTED_MODULE_4__["DomSanitizer"] }
];
TermosContratoCadastroComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_3__["Component"])({
        selector: 'dtp-termos-contrato-cadastro',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./termos-contrato-cadastro.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/uboi/paginas/termos-contrato/termos-contrato-cadastro/termos-contrato-cadastro.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./termos-contrato-cadastro.component.css */ "./src/app/uboi/paginas/termos-contrato/termos-contrato-cadastro/termos-contrato-cadastro.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_base_services_jbs_parametro_service__WEBPACK_IMPORTED_MODULE_2__["JbsParametroService"], _angular_platform_browser__WEBPACK_IMPORTED_MODULE_4__["DomSanitizer"]])
], TermosContratoCadastroComponent);



/***/ }),

/***/ "./src/app/uboi/uboi-base.module.ts":
/*!******************************************!*\
  !*** ./src/app/uboi/uboi-base.module.ts ***!
  \******************************************/
/*! exports provided: UboiBaseModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UboiBaseModule", function() { return UboiBaseModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var dtp_angular_library__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! dtp-angular-library */ "./node_modules/dtp-angular-library/fesm2015/dtp-angular-library.js");
/* harmony import */ var agm_direction__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! agm-direction */ "./node_modules/agm-direction/fesm2015/agm-direction.js");
/* harmony import */ var _agm_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @agm/core */ "./node_modules/@agm/core/fesm2015/agm-core.js");
/* harmony import */ var ngx_mask__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ngx-mask */ "./node_modules/ngx-mask/fesm2015/ngx-mask.js");
/* harmony import */ var _componentes_componentes_module__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./componentes/componentes.module */ "./src/app/uboi/componentes/componentes.module.ts");










let UboiBaseModule = class UboiBaseModule {
};
UboiBaseModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["NgModule"])({
        declarations: [],
        exports: [
            _angular_common__WEBPACK_IMPORTED_MODULE_1__["CommonModule"],
            dtp_angular_library__WEBPACK_IMPORTED_MODULE_5__["DtpAngularLibraryModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormsModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_3__["ReactiveFormsModule"],
            _angular_router__WEBPACK_IMPORTED_MODULE_4__["RouterModule"],
            ngx_mask__WEBPACK_IMPORTED_MODULE_8__["NgxMaskModule"],
            _agm_core__WEBPACK_IMPORTED_MODULE_7__["AgmCoreModule"],
            agm_direction__WEBPACK_IMPORTED_MODULE_6__["AgmDirectionModule"]
        ],
        imports: [
            _angular_common__WEBPACK_IMPORTED_MODULE_1__["CommonModule"],
            dtp_angular_library__WEBPACK_IMPORTED_MODULE_5__["DtpAngularLibraryModule"],
            _componentes_componentes_module__WEBPACK_IMPORTED_MODULE_9__["ComponentesModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormsModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_3__["ReactiveFormsModule"],
            _angular_router__WEBPACK_IMPORTED_MODULE_4__["RouterModule"],
            ngx_mask__WEBPACK_IMPORTED_MODULE_8__["NgxMaskModule"].forRoot(),
            _agm_core__WEBPACK_IMPORTED_MODULE_7__["AgmCoreModule"].forRoot({
                apiKey: 'AIzaSyAQrbdTyHu4T6inTEvD5E4XVIUliMuqCa4'
            }),
            agm_direction__WEBPACK_IMPORTED_MODULE_6__["AgmDirectionModule"],
        ]
    })
], UboiBaseModule);



/***/ }),

/***/ "./src/app/uboi/uboi-routing.module.ts":
/*!*********************************************!*\
  !*** ./src/app/uboi/uboi-routing.module.ts ***!
  \*********************************************/
/*! exports provided: UBoiRoutingModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UBoiRoutingModule", function() { return UBoiRoutingModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _paginas_termos_contrato_termos_contrato_cadastro_termos_contrato_cadastro_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./paginas/termos-contrato/termos-contrato-cadastro/termos-contrato-cadastro.component */ "./src/app/uboi/paginas/termos-contrato/termos-contrato-cadastro/termos-contrato-cadastro.component.ts");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _core_inicio_inicio_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./core/inicio/inicio.component */ "./src/app/uboi/core/inicio/inicio.component.ts");
/* harmony import */ var dtp_angular_library__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! dtp-angular-library */ "./node_modules/dtp-angular-library/fesm2015/dtp-angular-library.js");
/* harmony import */ var _core_autorizacao_login_login_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./core/autorizacao/login/login.component */ "./src/app/uboi/core/autorizacao/login/login.component.ts");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _core_autorizacao_two_factor_two_factor_component__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./core/autorizacao/two-factor/two-factor.component */ "./src/app/uboi/core/autorizacao/two-factor/two-factor.component.ts");








const routes = [
    {
        path: "login",
        component: _core_autorizacao_login_login_component__WEBPACK_IMPORTED_MODULE_5__["LoginComponent"],
        data: { titulo: "Login" },
    },
    {
        path: "two-factor-auth",
        component: _core_autorizacao_two_factor_two_factor_component__WEBPACK_IMPORTED_MODULE_7__["TwoFactorComponent"],
        data: { titulo: "Login Dois Fatores" },
    },
    {
        path: "inicio",
        component: _core_inicio_inicio_component__WEBPACK_IMPORTED_MODULE_3__["InicioComponent"],
        canActivate: [dtp_angular_library__WEBPACK_IMPORTED_MODULE_4__["AuthGuardianService"]],
        data: { titulo: "Inicio" },
    },
    {
        path: "",
        component: _core_inicio_inicio_component__WEBPACK_IMPORTED_MODULE_3__["InicioComponent"],
        canActivate: [dtp_angular_library__WEBPACK_IMPORTED_MODULE_4__["AuthGuardianService"]],
        data: { titulo: "Inicio" },
    },
    {
        path: "termos-de-uso",
        component: _paginas_termos_contrato_termos_contrato_cadastro_termos_contrato_cadastro_component__WEBPACK_IMPORTED_MODULE_1__["TermosContratoCadastroComponent"],
        canActivate: [dtp_angular_library__WEBPACK_IMPORTED_MODULE_4__["AuthGuardianService"]],
        data: { titulo: "Termos de Uso" },
    },
    {
        path: "cadastro",
        loadChildren: () => Promise.all(/*! import() | paginas-cadastro-cadastro-module */[__webpack_require__.e("common"), __webpack_require__.e("paginas-cadastro-cadastro-module")]).then(__webpack_require__.bind(null, /*! ./paginas/cadastro/cadastro.module */ "./src/app/uboi/paginas/cadastro/cadastro.module.ts")).then((m) => m.CadastroModule),
        data: { titulo: "Cadastro" },
    },
    {
        path: "checklist",
        loadChildren: () => __webpack_require__.e(/*! import() | paginas-checklist-checklist-module */ "paginas-checklist-checklist-module").then(__webpack_require__.bind(null, /*! ./paginas/checklist/checklist.module */ "./src/app/uboi/paginas/checklist/checklist.module.ts")).then((m) => m.ChecklistModule),
        data: { titulo: "Checklist" },
    },
    {
        path: "envio-para-transportadora",
        loadChildren: () => Promise.all(/*! import() | paginas-envio-para-transportadora-envio-para-transportadora-module */[__webpack_require__.e("default~paginas-envio-para-transportadora-envio-para-transportadora-module~paginas-tagueamento-xls-t~46b389c9"), __webpack_require__.e("default~paginas-envio-para-transportadora-envio-para-transportadora-module~paginas-viagem-viagem-module"), __webpack_require__.e("paginas-envio-para-transportadora-envio-para-transportadora-module")]).then(__webpack_require__.bind(null, /*! ./paginas/envio-para-transportadora/envio-para-transportadora.module */ "./src/app/uboi/paginas/envio-para-transportadora/envio-para-transportadora.module.ts")).then((m) => m.SendOrderModule),
        data: { titulo: "Envio para a transportadora" },
    },
    {
        path: "grupo-contato",
        loadChildren: () => __webpack_require__.e(/*! import() | paginas-grupo-contato-grupo-contato-module */ "paginas-grupo-contato-grupo-contato-module").then(__webpack_require__.bind(null, /*! ./paginas/grupo-contato/grupo-contato.module */ "./src/app/uboi/paginas/grupo-contato/grupo-contato.module.ts")).then((m) => m.GrupoContatoModule),
        data: { titulo: "Grupo Contato" },
    },
    {
        //GAMBIARRA
        path: "pedido",
        loadChildren: () => Promise.all(/*! import() | paginas-viagem-viagem-module */[__webpack_require__.e("default~paginas-envio-para-transportadora-envio-para-transportadora-module~paginas-tagueamento-xls-t~46b389c9"), __webpack_require__.e("default~paginas-envio-para-transportadora-envio-para-transportadora-module~paginas-viagem-viagem-module"), __webpack_require__.e("paginas-viagem-viagem-module")]).then(__webpack_require__.bind(null, /*! ./paginas/viagem/viagem.module */ "./src/app/uboi/paginas/viagem/viagem.module.ts")).then((m) => m.ViagemModule),
        data: { titulo: "Pedido" },
    },
    {
        path: "tracking",
        loadChildren: () => Promise.all(/*! import() | paginas-viagem-viagem-module */[__webpack_require__.e("default~paginas-envio-para-transportadora-envio-para-transportadora-module~paginas-tagueamento-xls-t~46b389c9"), __webpack_require__.e("default~paginas-envio-para-transportadora-envio-para-transportadora-module~paginas-viagem-viagem-module"), __webpack_require__.e("paginas-viagem-viagem-module")]).then(__webpack_require__.bind(null, /*! ./paginas/viagem/viagem.module */ "./src/app/uboi/paginas/viagem/viagem.module.ts")).then((m) => m.ViagemModule),
        data: { titulo: "tracking" },
    },
    {
        path: "perfil",
        loadChildren: () => __webpack_require__.e(/*! import() | paginas-perfil-perfil-module */ "paginas-perfil-perfil-module").then(__webpack_require__.bind(null, /*! ./paginas/perfil/perfil.module */ "./src/app/uboi/paginas/perfil/perfil.module.ts")).then((m) => m.PerfilModule),
        data: { titulo: "Perfil" },
    },
    {
        path: "usuario",
        loadChildren: () => __webpack_require__.e(/*! import() | paginas-usuario-usuario-module */ "paginas-usuario-usuario-module").then(__webpack_require__.bind(null, /*! ./paginas/usuario/usuario.module */ "./src/app/uboi/paginas/usuario/usuario.module.ts")).then((m) => m.UsuarioModule),
        data: { titulo: "Usuário" },
    },
    {
        path: "dados-tagueamento",
        loadChildren: () => Promise.all(/*! import() | paginas-tagueamento-xls-tagueamento-xls-module */[__webpack_require__.e("default~paginas-envio-para-transportadora-envio-para-transportadora-module~paginas-tagueamento-xls-t~46b389c9"), __webpack_require__.e("paginas-tagueamento-xls-tagueamento-xls-module")]).then(__webpack_require__.bind(null, /*! ./paginas/tagueamento-xls/tagueamento-xls.module */ "./src/app/uboi/paginas/tagueamento-xls/tagueamento-xls.module.ts")).then((m) => m.TagueamentoXlsModule),
        data: { titulo: "Dados Tagueamento" },
    },
    {
        path: "parceria",
        loadChildren: () => Promise.all(/*! import() | paginas-parceria-parceria-module */[__webpack_require__.e("common"), __webpack_require__.e("paginas-parceria-parceria-module")]).then(__webpack_require__.bind(null, /*! ./paginas/parceria/parceria.module */ "./src/app/uboi/paginas/parceria/parceria.module.ts")).then((m) => m.ParceriaModule),
        data: { titulo: "Parceria" },
    },
    {
        path: "transportadora",
        loadChildren: () => Promise.all(/*! import() | paginas-transportadora-transportadora-module */[__webpack_require__.e("common"), __webpack_require__.e("paginas-transportadora-transportadora-module")]).then(__webpack_require__.bind(null, /*! ./paginas/transportadora/transportadora.module */ "./src/app/uboi/paginas/transportadora/transportadora.module.ts")).then((m) => m.TransportadoraModule),
        data: { titulo: "Transportadora" },
    },
    {
        path: "escalador",
        loadChildren: () => Promise.all(/*! import() | paginas-escalador-escalador-module */[__webpack_require__.e("common"), __webpack_require__.e("paginas-escalador-escalador-module")]).then(__webpack_require__.bind(null, /*! ./paginas/escalador/escalador.module */ "./src/app/uboi/paginas/escalador/escalador.module.ts")).then((m) => m.EscaladorModule),
        data: { titulo: "Escalador" },
    },
];
let UBoiRoutingModule = class UBoiRoutingModule {
};
UBoiRoutingModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_6__["NgModule"])({
        declarations: [],
        imports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"].forChild(routes)],
        exports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"]]
    })
], UBoiRoutingModule);



/***/ }),

/***/ "./src/app/uboi/uboi.module.ts":
/*!*************************************!*\
  !*** ./src/app/uboi/uboi.module.ts ***!
  \*************************************/
/*! exports provided: UboiModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UboiModule", function() { return UboiModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _paginas_termos_contrato_termos_contrato_cadastro_termos_contrato_cadastro_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./paginas/termos-contrato/termos-contrato-cadastro/termos-contrato-cadastro.component */ "./src/app/uboi/paginas/termos-contrato/termos-contrato-cadastro/termos-contrato-cadastro.component.ts");
/* harmony import */ var _paginas_inicio_pagina_inicio_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./paginas/inicio/pagina-inicio.component */ "./src/app/uboi/paginas/inicio/pagina-inicio.component.ts");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _uboi_base_module__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./uboi-base.module */ "./src/app/uboi/uboi-base.module.ts");
/* harmony import */ var _uboi_routing_module__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./uboi-routing.module */ "./src/app/uboi/uboi-routing.module.ts");
/* harmony import */ var _core_inicio_inicio_component__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./core/inicio/inicio.component */ "./src/app/uboi/core/inicio/inicio.component.ts");
/* harmony import */ var _core_autorizacao_autorizacao_module__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./core/autorizacao/autorizacao.module */ "./src/app/uboi/core/autorizacao/autorizacao.module.ts");
/* harmony import */ var _directives_DirectivesModule__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./directives/DirectivesModule */ "./src/app/uboi/directives/DirectivesModule.ts");









let UboiModule = class UboiModule {
};
UboiModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_3__["NgModule"])({
        declarations: [
            _core_inicio_inicio_component__WEBPACK_IMPORTED_MODULE_6__["InicioComponent"],
            _paginas_inicio_pagina_inicio_component__WEBPACK_IMPORTED_MODULE_2__["PaginaInicioComponent"],
            _paginas_termos_contrato_termos_contrato_cadastro_termos_contrato_cadastro_component__WEBPACK_IMPORTED_MODULE_1__["TermosContratoCadastroComponent"]
        ],
        exports: [_core_inicio_inicio_component__WEBPACK_IMPORTED_MODULE_6__["InicioComponent"], _paginas_inicio_pagina_inicio_component__WEBPACK_IMPORTED_MODULE_2__["PaginaInicioComponent"], _uboi_base_module__WEBPACK_IMPORTED_MODULE_4__["UboiBaseModule"], _directives_DirectivesModule__WEBPACK_IMPORTED_MODULE_8__["DirectivesModule"]],
        imports: [
            _uboi_base_module__WEBPACK_IMPORTED_MODULE_4__["UboiBaseModule"],
            _core_autorizacao_autorizacao_module__WEBPACK_IMPORTED_MODULE_7__["AutorizacaoModule"],
            _uboi_routing_module__WEBPACK_IMPORTED_MODULE_5__["UBoiRoutingModule"],
            _directives_DirectivesModule__WEBPACK_IMPORTED_MODULE_8__["DirectivesModule"]
        ]
    })
], UboiModule);



/***/ }),

/***/ "./src/environments/environment.ts":
/*!*****************************************!*\
  !*** ./src/environments/environment.ts ***!
  \*****************************************/
/*! exports provided: environment */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "environment", function() { return environment; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const environment = {
    production: false,
    urlApi: "https://portalapi-hml.uboi.com.br/api/",
    urlUpload: "https://portalapi-hml.uboi.com.br/api/upload",
    diretorioAnexos: "D:/GitRepositorio/Datapar.VisualRodopar/Portal.WR.WebApi/Resources/Files",
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.


/***/ }),

/***/ "./src/main.ts":
/*!*********************!*\
  !*** ./src/main.ts ***!
  \*********************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/platform-browser-dynamic */ "./node_modules/@angular/platform-browser-dynamic/fesm2015/platform-browser-dynamic.js");
/* harmony import */ var _app_app_module__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./app/app.module */ "./src/app/app.module.ts");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./environments/environment */ "./src/environments/environment.ts");





if (_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].production) {
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["enableProdMode"])();
}
Object(_angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_2__["platformBrowserDynamic"])().bootstrapModule(_app_app_module__WEBPACK_IMPORTED_MODULE_3__["AppModule"])
    .catch(err => console.error(err));


/***/ }),

/***/ 0:
/*!***************************!*\
  !*** multi ./src/main.ts ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! /app/src/main.ts */"./src/main.ts");


/***/ })

},[[0,"runtime","vendor"]]]);
//# sourceMappingURL=main-es2015.js.map